import * as api from "../../shared/api";
import * as biz_data_helper from "../../shared/biz_data_helper";
import apiPath from "../../shared/apiPath";

const content_type = "sNotifyTemplate";

const create = function () {
  return {
    content_type: "muji",
    age: 29
  };
};
const fields = [
  {
    key: "id",
    label: "编号",
    sortable: true,
    type: "button",
    button: {
      type: "text"
    }
  },
  {
    key: "category",
    label: "类别",
    sortable: true
  },
  {
    key: "notify_type",
    label: "类型",
    sortable: true
  },
  {
    key: "subject",
    label: "标题",
    sortable: true
  }
];
const fields2 = [
  {
    key: "id",
    label: "编号",
    sortable: true,
    thStyle: {
      width: "60px"
    }
  },
  {
    key: "username",
    label: "用户名",
    sortable: true
  },
  {
    key: "realname",
    label: "真实姓名",
    sortable: true
  },
  {
    key: "is_valid",
    label: "启用",
    type: "boolean"
  }
];

const dataForm = {
  id: "",
  category: "",
  notify_type: "",
  subject: "",
  content: ""
};

///前端验证
const rules = {
  notify_type: [
    {
      required: true,
      message: "请输入类型",
      trigger: "blur"
    }
  ],
  subject: [
    {
      required: true,
      message: "请输入标题",
      trigger: "blur"
    }
  ],
  content: [
    {
      required: true,
      message: "内容不能为空",
      trigger: "blur"
    }
  ]
};

const descriptor = {
  name: {
    type: "string",
    required: true,
    validator: (rule, value) => value === "muji"
  },
  age: {
    type: "number",
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api
          .request({
            url: biz_data_helper.get_endpoint("test_fetch").url,
            parameters: {
              c: "a666"
            }
          })
          .then(res => {


            if (value == res.data[0].echo) {
              resolve(res);
            } else {
              reject("测试没通过");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};
const methods = {
  async GetNotifyTemplates() {
    const biz_data = new biz_data_helper.base_entity_helper(
      "get_NotifyTemplate",
      {},
      {}
    );
    let _fields = _.map(fields, "key");
    _fields.push("content");
    let result = await biz_data
      .execAction({
        params: {},
        fields: _fields
      })
      .run();
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  },
  //新增或修改notify
  async addAndUpdate(data) {
    //新增
    if (data.id == "") {
      const biz_data = new biz_data_helper.base_entity_helper(
        "add_NotifyTemplate",
        {},
        {}
      );
      let result = await biz_data
        .execAction({
          params: data,
          fields: ["id"]
        })
        .run();
      if (
        result &&
        result[0].result &&
        result[0].result.data &&
        result[0].result.data.ActionResult &&
        result[0].result.data.ActionResult.Result &&
        result[0].result.data.ActionResult.Result.Data.length > 0
      ) {
        return result[0].result.data.ActionResult.Result.Data;
      } else {
        return null;
      }
    }
    {
      const biz_data = new biz_data_helper.base_entity_helper(
        "update_NotifyTemplate",
        {},
        {}
      );
      let result = await biz_data
        .execAction({
          params: data,
          fields: ["id"]
        })
        .run();
      if (
        result &&
        result[0].result &&
        result[0].result.data &&
        result[0].result.data.ActionResult
      ) {
        return result[0].result.data.ActionResult;
      } else {
        return null;
      }
    }
    // let result = null;
    // let biz_data = new biz_data_helper.base_entity_helper(
    //   content_type,
    //   create,
    //   descriptor
    // );
    // result = await biz_data
    //   .insertAction({
    //     params: data,
    //     fields: _.map(fields, "key")
    //   })
    //   .run();

    // if (
    //   result &&
    //   result[0].result &&
    //   result[0].result.data &&
    //   result[0].result.data.ActionResult &&
    //   result[0].result.data.ActionResult.Result &&
    //   result[0].result.data.ActionResult.Result.Data.length > 0
    // ) {
    //   return result[0].result.data.ActionResult.Result.Data;
    // } else {
    //   return null;
    // }
  },
  //新增或删除通知--用户
  async AddORDeleteNotifyUsers(data) {
    let result = null;
    let biz_data = new biz_data_helper.base_entity_helper(
      content_type,
      create,
      descriptor
    );
    result = await biz_data
      .insertAction({
        params: data,
        fields: _.map(fields, "key")
      })
      .run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  },
  //更改notify状态
  async UpdateNotify(_data) {
    let is_deleted = false;
    let datas = _data.selected_items;
    // console.log(datas)
    switch (_data.state) {
      case "deleted":
        //删除
        is_deleted = true;
        break;
      default:
        break;
    }
    let query_settings = [];

    if (!is_deleted) {
      // 修改操作
    } else {
      // 删除操作
      for (var i in datas) {
        let _p = new FormData();
        _p.append("notifyType", datas[i].notify_type);
        query_settings.push({
          url: apiPath.admin.remove_notify_type,
          parameters: _p,
          method: "post"
        });
      }
      let data = await api.query_all_async(query_settings);
      if (data) {
        return data[0].result.data.Success;
      } else {
        return false;
      }
    }
  },
  //获取权限
  async GetNotifyUsers(notify_type) {
    let data = await api.query_async({
      url: apiPath.admin.get_notify_users,
      parameters: {
        notifyType: notify_type
      },
      method: "get"
    });
    if (data && data[0] && data[0].result) {
      return data[0].result.data.Result;
    }
    return null;
  },
  async GetRoleOwnPrivilege(roleId) {
    let data = await api.query_async({
      url: apiPath.admin.get_role_own_privilege_list + roleId,
      parameters: null,
      method: "get"
    });
    if (data) {
      return data[0].result.data.Result;
    }
    return null;
  }
};

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
);
// export * from "../../shared/biz_data_helper"
export { fields, fields2, dataForm, rules, biz_data, methods };
